import { Autocomplete, ListItem, ListItemText, TextField } from '@mui/material'

import { PublicUser } from '../../../providers/users'

interface UsersAutocompleteProps {
  id: string
  label: string
  users: PublicUser[]
  value?: PublicUser[]
  usersLoading: boolean
  usersError: string
  componentLoading: boolean
  multiple: boolean
  onChangeCallback: (e: any, v: any) => void
}

export default function UsersAutocomplete(props: UsersAutocompleteProps) {
  const {
    id,
    label,
    users,
    value,
    usersLoading,
    usersError,
    multiple,
    componentLoading,
    onChangeCallback,
  } = props

  const compareUsers = (userOne: PublicUser, userTwo: PublicUser) => {
    return (
      userOne.uid === userTwo.uid &&
      userOne.displayName === userTwo.displayName &&
      userOne.email === userTwo.email &&
      userOne.phoneNumber === userTwo.phoneNumber
    )
  }

  return (
    <Autocomplete
      disabled={componentLoading}
      loading={usersLoading || usersError != null}
      loadingText={usersError != null ? usersError : 'loading..'}
      multiple={multiple}
      id={id}
      value={value!}
      defaultValue={value}
      options={users}
      limitTags={1}
      getOptionLabel={(user) => user.displayName}
      isOptionEqualToValue={(option, value) => compareUsers(option, value)}
      onChange={onChangeCallback}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={label}
          placeholder={label}
        />
      )}
      renderOption={(props, option: PublicUser) => {
        return (
          <ListItem {...props} key={option.uid}>
            <ListItemText
              primary={option.displayName}
              secondary={option.email}
            ></ListItemText>
          </ListItem>
        )
      }}
    />
  )
}
